import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Localize_Response } from "@/interfaces/api/localize/api_response_types"
import { getLocalize } from "../requests/localize"

type LocalizeOptions = Omit<
  UseQueryOptions<API_Data_Localize_Response, API_Error, API_Data_Localize_Response, ['localize']>,
  'queryKey' | 'queryFn'
>

export const useLocalize = (options?: LocalizeOptions) => 
  useQuery<API_Data_Localize_Response, API_Error, API_Data_Localize_Response, ['localize']>({
    queryKey: ['localize'],
    retry: false,
    queryFn: () => getLocalize(),
    ...options
  })